<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="老师点评" v-model="hideShow" width="630px" persistent>
			<v-card>
				<v-card-title>
					<span>课堂点评(按学员)</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-3">
					<v-row dense>
						<v-col cols="12" class="text-body-1">
							学生姓名: <span class="text-h6 info--text">{{studentName}}</span>
						</v-col>
						<v-col cols="12" class="d-flex">
							<span class="text-body-1">课堂表现评分:</span>
							<div class="mt-n2">
								<v-rating v-model="rate.rateScore" color="yellow darken-3"
									background-color="grey darken-1" empty-icon="$ratingFull" hover></v-rating>
							</div>
							
						</v-col>
						<v-col cols="12" class="mt-n1">
							<v-textarea label="请输入课堂点评内容" no-resize rows="4" v-model="rate.content" outlined dense
								clearable></v-textarea>
						</v-col>
						<v-col cols="12" class="d-flex mt-n5">
							<!-- <v-file-input v-model="upload.files" @change="fileSelected" prepend-icon="mdi-camera"
								label="上传图片" multiple placeholder="请选择图片" dense outlined accept="image/png, image/jpeg"
								counter :show-size="1000">
								<template v-slot:selection="{ index, text }">
									<v-chip v-if="index < 2"  dark label small>
										{{ text }}
									</v-chip>
									<span v-else-if="index === 2" class="text-overline mx-2">
										+{{ upload.files.length - 2 }}个文件
									</span>
								</template>
							</v-file-input> -->
							<div>
								<!-- 上传图片组件 -->
								<cutImageUpload title="上传作品" :viewPrevImage="false" :boxWidth="800" :boxHeight="600" :cutWidth="600" :cutHeight="600" :rate="upload.cutRate"  @success="uploadSuccess"></cutImageUpload>
							</div>
							<div class="mt-2 d-flex">
								<span>图片宽高比:</span>
								<div class="mt-n5 ml-1">
									<v-radio-group v-model="upload.cutRate" row >
									    <v-radio label="1:1"  value="1:1" ></v-radio>
									    <v-radio label="3:4"  value="3:4" ></v-radio>    
									    <v-radio label="4:3"  value="4:3" ></v-radio>
									</v-radio-group>
								</div>
								
							</div>
						</v-col>
						<v-col cols="12" class="d-flex mt-n3 " >
							<v-card v-if="upload.imgList" v-for="(item,index) in upload.imgList" :key="index" width="100" class="mr-3">
								<v-img :src="imgPrev + item" height="100">
									<v-app-bar flat color="rgba(0, 0, 0, 0.2)" height="25">									
										<v-spacer></v-spacer>
										<v-btn color="white" x-small icon @click="upload.imgList.splice(index,1)">
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</v-app-bar>
								</v-img>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitAddRate" :disabled="rate.submitting" :loading="rate.submitting" color="success">
						确定
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import * as qiniu from 'qiniu-js'
	import storage from "../config/storage"
	import utils from '../config/utils'
	import cutImageUpload from './cut_image_upload.vue'
	export default {
		name:"rate-student-class",
		components:{cutImageUpload},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			detailId:{
				type:String,
				default:""
			},
			studentName:{
				type:String,
				default:""
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.rate.content = "";
					this.rate.rateScore = 5;
					this.upload.imgList = [];
	
				}
			}
		},
		data(){
			return {
				imgPrev:"https://photo.youkeya.cn/",
				hideShow:this.show,
				rate:{
					submitting:false,
					rateScore:5,
					content:"",

				},
				upload: {
					cutRate:"1:1",
					imgList: [], //上传图片结果
				
				},
			}
		},
		mounted() {
			console.log("approve-record mounted");
		},
		methods:{
			uploadSuccess(e){
			
				if (this.upload.imgList && this.upload.imgList.length >= 3){
					this.$noty.error('最多上传3张照片');
					return
				}
				this.upload.imgList.push(e.key);
			},
			cancel(){
				this.$emit("cancel","");
			},
			submitAddRate() {
			
				if (!this.detailId) {
					this.$noty.error('ID不能为空');
					return
				}
				if (!this.rate.rateScore) {
					this.$noty.error('评分不能为空');
					return
				}
					
				if (!this.rate.content) {
					this.$noty.error('点评内容不能为空');
					return
				}
				let imgList = this.upload.imgList; // 上传的图片KEY
				
				
				this.rate.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/detail/rate/create`;
				let postData = {
					detailId:this.detailId,
					rateScore:this.rate.rateScore,
					content:this.rate.content,
				};
				postData.imgList = imgList;
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("点评成功");
							
							that.rate.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.rate.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.rate.submitting = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			},
		}
	}
	
</script>

<style>
</style>
